export const defaultPalette = {
  themePrimary: "#6264a7",
  themeLighterAlt: "#f4f4f9",
  themeLighter: "#e3e3ef",
  themeLight: "#babbd8",
  themeTertiary: "#898bbc",
  themeSecondary: "#696baa",
  themeDarkAlt: "rgba(37, 36, 36, 0.75);",
  themeDark: "#3d3f6c",
  themeDarker: "#34365c",
  neutralLighterAlt: "#f8f8f8",
  neutralLighter: "#f3f2f1", //  $app-gray-10, hover
  neutralLight: "#ffffff", // $app-white, selected
  neutralQuaternaryAlt: "#fcfcfb", // $app-white, selected + hover
  neutralQuaternary: "#d0d0d0",
  neutralTertiaryAlt: "#c8c8c8",
  neutralTertiary: "#b6b4b4",
  neutralSecondary: "#9f9c9c",
  neutralPrimaryAlt: "#878383",
  neutralPrimary: "#252424",
  neutralDark: "#575454",
  black: "#3f3d3d",
  white: "#f9f8f7",
  primaryBackground: "#f9f8f7",
  primaryText: "rgba(37, 36, 36, 0.75);",
  bodyBackground: "#f9f8f7",
  bodyText: "rgba(37, 36, 36, 0.75);",
  disabledBackground: "#f4f4f4",
  disabledText: "#c8c8c8",
  boxShadowColor: "rgba(0, 0, 0, .5);",
  appGray02: "rgba(37, 36, 36, 0.75);", // $app-gray-02,
  appGray04: "#979593",
  appGray06: "rgba(37, 36, 36, 0.3);",
  appGray10: "#f3f2f1",
  appWhite: "#fff",
  appBlackFull: "#000"
};

export const darkPalette = {
  themePrimary: "#6264a7",
  themeLighterAlt: "#07070c",
  themeLighter: "#11121e",
  themeLight: "#2a2b49",
  themeTertiary: "#48497e",
  themeSecondary: "#5b5ea1",
  themeDarkAlt: "#7274af",
  themeDark: "#9a9cc6",
  themeDarker: "#a9aace",
  neutralLighterAlt: "#373636",
  neutralLighter: "#313030", // $app-gray-10-darktheme, hover
  neutralLight: "#201f1f", // $app-black-darktheme, selected
  neutralQuaternaryAlt: "#1e1d1d", // $app-black-darktheme, selected + hover
  neutralQuaternary: "#5c5a5a",
  neutralTertiaryAlt: "#787575",
  neutralTertiary: "#c8c8c8",
  neutralSecondary: "#d0d0d0",
  neutralPrimaryAlt: "#dadada",
  neutralPrimary: "#ffffff",
  neutralDark: "#f4f4f4",
  black: "#f8f8f8",
  white: "#2d2c2c",
  primaryBackground: "#2d2c2c",
  primaryText: "#fff",
  bodyBackground: "#2d2c2c",
  bodyText: "#fff",
  disabledBackground: "#2c2b2b",
  disabledText: "#242323",
  boxShadowColor: "rgba(0, 0, 0, .5);",
  appGray02: "rgba(255, 255, 255, .75);", // $app-gray-02-darktheme,
  appGray04: "#979593",
  appGray06: "rgba(255, 255, 255, 0.3);",
  appGray10: "#2d2c2c", // $app-gray-10-darktheme
  appWhite: "#fff", // $app-white
  appBlackFull: "#000" // $app-black-full
};

export const contrastPalette = {
  themePrimary: "#ffff01",
  themeLighterAlt: "#121200",
  themeLighter: "#2e2e00",
  themeLight: "#6f6f00",
  themeTertiary: "#c0c000",
  themeSecondary: "#f4f400",
  themeDarkAlt: "#ffff19",
  themeDark: "#ffff5c",
  themeDarker: "#ffff73",
  neutralLighterAlt: "#0b0b0b",
  neutralLighter: "#151515",
  neutralLight: "#252525",
  neutralQuaternaryAlt: "#2f2f2f",
  neutralQuaternary: "#373737",
  neutralTertiaryAlt: "#595959",
  neutralTertiary: "#c8c8c8",
  neutralSecondary: "#d0d0d0",
  neutralPrimaryAlt: "#dadada",
  neutralPrimary: "#fff",
  neutralDark: "#f4f4f4",
  black: "#f8f8f8",
  white: "#000",
  primaryBackground: "#000",
  primaryText: "#fff", // $app-acc-text-color
  bodyBackground: "#000",
  bodyText: "#fff",
  disabledBackground: "#NaNNaNNaN",
  disabledText: "#NaNNaNNaN",
  boxShadowColor: "rgba(0, 0, 0, .5);",
  appGray02: "#fff", // $app-acc-text-color
  appGray04: "#979593",
  appGray06: "#000",
  appGray10: "#000", // $app-acc-background-color
  appWhite: "#fff", // $app-white
  appBlackFull: "#000" // app-black-full
};
